import React, { Component, Fragment } from 'react';

import ItemsSelect from './ItemsSelect';
import FieldsTemplate from './FieldsTemplate';
class StringTempleteRender extends Component {
    constructor() {
        super();

        this.state = {
            selectedItem: {
                type: {
                    id: -1,
                    value: ''
                },
                settings: ''
            },
            itemValue: ''
        }

        this.changeState = this.changeState.bind(this);
    }

    componentDidUpdate(prevProps) {

        const { selectedItem } = this.props;

        if (prevProps.selectedItem !== selectedItem) {
            const isTypeString = typeof selectedItem.settings === 'string';
            const transformedSettings = isTypeString ? this.getFieldsFromString(selectedItem.settings) : selectedItem.settings;

            this.setState({
                ...this.state,
                selectedItem: {
                    ...selectedItem,
                    settings: transformedSettings
                },
                itemValue: selectedItem.type.value
            });
        }
    }

    changeState({ target }) {

        this.setState(
            {
                ...this.state,
                itemValue: target.value,
                selectedItem: {
                    ...this.state.selectedItem,
                    type: {
                        id: target.options[target.options.selectedIndex].id,
                        value: target.value,
                        template: target.options[target.options.selectedIndex].dataset.template
                    },
                    settings: this.getFieldsFromString(target.options[target.options.selectedIndex].dataset.template)
                },
            },
            () => this.props.updateSettings(this.state.selectedItem)
        );
    }

    getFieldsFromString(stringOfFields) {

        let template = JSON.parse(stringOfFields);
        let fieldsWithValue = {};

        if (!template) {
            return null;
        }
        /**
         * First time when the keys are empty it comes as an array
         * Probbably some backend inconsistency
         */
        if (Array.isArray(template)) {

            template.map(field => {
                fieldsWithValue = { ...fieldsWithValue, [field]: '' };
            });

            template = fieldsWithValue;
        }

        return template;
    }

    updateFieldValue = ({ target }) => {

        this.setState(
            {
                ...this.state,
                selectedItem: {
                    ...this.state.selectedItem,
                    settings: {
                        [target.name]: target.value
                    }
                }
            },
            () => this.props.updateSettings(this.state.selectedItem)
        );
    };

    render() {

        return (
            <Fragment>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <ItemsSelect
                        items={this.props.items}
                        selectLabel={this.props.selectLabel}
                        selectOnChange={this.changeState}
                        selectInputValue={this.state.itemValue}
                        selectInputDefaultOption={this.props.selectInputDefaultOption}
                    />
                    {/** This accepts all the components that need to be on one row 
                     * with the ItemsSelect.
                     */}
                    {this.props.renderSelectSibling}
                </div>
                <FieldsTemplate
                    fields={this.state.selectedItem.settings}
                    update={this.updateFieldValue}
                />
            </Fragment>
        );
    }
}

export default StringTempleteRender;


// WEBPACK FOOTER //
// ./src/components/common/stringTemplateRenderer/StringTemplateRenderer.js